@if (cweEntries().length) {
  <p class="finding-cwe">
    @for (cweEntry of cweEntries(); track cweEntry.id; let last = $last) {
      <span class="finding-cwe-entry" [matTooltip]="cweEntry.full">
        <a
          class="external-link"
          [href]="cweEntry.url"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="cweEntry.short + ' opens in a new tab'"
          >{{ cweEntry.short }}</a
        >
      </span>
      @if (!last) {
        <span>, </span>
      }
    }
  </p>
}
